/**
 * Capitalizes the first letter of a string and converts the rest of the letters to lowercase.
 * 
 * @param value - The string to be capitalized.
 * @returns The capitalized string.
 */
export function ucfirst(value: string): string {
    if (!value || typeof value !== 'string') {
        return value;
    }
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
